import "./progressStepper.scss";

const ProgressStepper = ({
  steps,
  currentStep,
  style,
  linePosition,
}: {
  steps: string[];
  currentStep?: number;
  style?: React.CSSProperties;
  linePosition?: React.CSSProperties;
}) => {
  return (
    <div className="progress-stepper-wrap" style={{ ...style }}>
      {steps.map((step, idx) => {
        return (
          <div key={idx} className={`step ${currentStep === idx ? "active" : ""}`}>
            <div className="circle">
              {currentStep && currentStep === idx ? (
                <i className="icon icon-10 icon-check-white" />
              ) : (
                idx + 1
              )}
            </div>
            <div className="label">{step}</div>
          </div>
        );
      })}
      <div className="line" style={{ ...linePosition }} />
    </div>
  );
};

export default ProgressStepper;
